
export class ProductGroup {
  public constructor (
    readonly id: number,
    readonly name: string,
  ) {}

  static createFromResponse (responseData: any): Array<ProductGroup> {
    let result: Array<ProductGroup> = []
    if (responseData) {
      result = responseData.map((item: any ) => {
        return new ProductGroup(
          item.id,
          item.name,
        )
      })
    }
    return result
  }
}
